// assets
import { IconDashboard, IconLayoutDashboard, IconReportSearch } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconLayoutDashboard, IconReportSearch };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'appdashboard',
            title: 'App Dashboard',
            type: 'item',
            url: '/dashboard/appdashboard',
            icon: icons.IconLayoutDashboard,
            breadcrumbs: false
        },
        {
            id: 'animesearch',
            title: 'Anime Search',
            type: 'item',
            url: '/dashboard/animesearch',
            icon: icons.IconReportSearch,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
